import React, { useState, useEffect, useRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.css';

import { useHistory } from 'react-router-dom';
import {useAllMeetings} from './reusableHooks';
import {signInAnon} from './authentication';

import Login from './Login';
import Survey from './Survey';
import Header from './Navbar';

function Home({thisUser}) {
  const user = thisUser;
  const [showLoginModal, setShowLogin] = useState(false);
  const [showSurveyModal, setShowSurvey] = useState(false);
  const [showSessionModal, setShowSessions] = useState(false);
  const history = useHistory();
  const mountedRef = useRef(false);
  
  const handleAdminClick = (event) => {
      if(user && !user.isAnonymous) history.push("/admin");
      else if (mountedRef.current) {
        setShowLogin(true);
      }
  }

  const handleAttendeeClick = (event) => {
    signInAnon().then(mountedRef.current && setShowSessions(true));
  }

  useEffect(() => {
    mountedRef.current = true;
    return () => {mountedRef.current = false;}
  }, [])

  return (
    <>  {!user?.flagged &&
        <>
       <Header/>
        <div className="d-flex flex-column justify-content-center w-md-75">
          <div className="row">
            <h1 className="greeting">CommunityClick-Virtual</h1>
          </div>
          <div className="row">
            <Button variant="secondary" size="lg" onClick={handleAttendeeClick} className="greetingButton w-auto"> I'm an attendee. </Button>
            <Button variant="secondary" size="lg" onClick={handleAdminClick} className="greetingButton w-auto"> I'm an organizer. </Button>
          </div>
        </div>
        <Login showModal={showLoginModal} setShow={setShowLogin}/>
        <Survey showModal={showSurveyModal} setShowSurvey={setShowSurvey} thisUser={user}/>
        <SessionModal showModal={showSessionModal} setShowSessions={setShowSessions} setShowSurvey={setShowSurvey}/>
        </>
      }
    </>
  );
}

function SessionModal({showModal, setShowSessions, setShowSurvey}) {
  const meetings = useAllMeetings();
  const mountedRef = useRef(false);

  const handleClose = () => {
    if(mountedRef.current) setShowSessions(false); 
  };

  const handleClickSession= (sessionId) => {
    localStorage.setItem("currentSession", sessionId);
    if(mountedRef.current) {
      setShowSessions(false); 
      setShowSurvey(true);
    }
  }

  useEffect(() => {
    mountedRef.current = true;
    return () => {mountedRef.current = false}
  }, [])

  return (
    <>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-lg" centered>
          <Modal.Header closeButton>
              <Modal.Title>Choose a session</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="meetings container-fluid">
            <div className="row">
              <h6 className="col-5 font-weight-bold text-left">
                Title
              </h6>
              <h6 className="col-4 font-weight-bold text-center">
                Date
              </h6>
              <h6 className="col-3 font-weight-bold text-right">
                Time
              </h6>
              {/*<h6 className="col-2 font-weight-bold">
              </h6>*/}
            </div>
            {meetings.map((meeting, index) => (
                <div key={meeting.id} className="row meeting py-2" onClick={() => handleClickSession(meeting.id)}>
                  <p key={meeting.id+"-name"} className="col-5 mb-0 text-left">{meeting.name}</p>
                  <p key={meeting.id+"-date"} className="col-4 mb-0 text-center">{meeting.date}</p>
                  <p key={meeting.id+"-time"} className="col-3 mb-0 text-right">
                  {
                    new Date('1970-01-01T' + meeting.time + 'Z')
                    .toLocaleTimeString({}, {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'})
                  }
                  </p>
                  {/*index === 0 && <p className="col-2 px-0">
                    <i className="fas fa-circle mr-2 text-danger blink"></i>
                    Live
                    </p>}
                  {index !== 0 && <p className="col-2 px-0 invisible"></p>*/}
                </div>
              ))}
          </div>
          </Modal.Body>
      </Modal>
    </>
  );
}

export default Home;
